import React from "react";
import { useParams } from "react-router-dom";
import ChatWidget from "@/components/ChatWidget";

export default function ChatbotPublicPage() {
  const { slug } = useParams();
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-8">
      <div className="max-w-lg text-center">
        <h1 className="font-[Outfit] text-3xl font-semibold text-slate-800 mb-3">
          Chatbot institucional
        </h1>
        <p className="text-sm text-slate-600 leading-relaxed">
          Esta página serve para testar o widget do setor <code className="text-[#1e5a8e]">{slug}</code>.
          Clique na bolha no canto inferior direito para conversar.
        </p>
      </div>
      <ChatWidget slug={slug} />
    </div>
  );
}
